import type { FaireProductEntity } from "../../entity_types/product";

export const p_77skx87o01: FaireProductEntity = {
  token: "p_77skx87o01",
  type: "product",
  name: "Mahjong Game Set",
  brandToken: "b_6xvu4qtx",
  brandName: "Verve Culture",
  imageUrl:
    "https://cdn.faire.com/fastly/a5a919e58e9b9cae8b6413a27262825dda2df3f3a76e86f9528d8edf6a176e32.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/34196aab266b1ea78e0b6f3f972eed8295e45621c5f9da08b62517dc59d4f728.jpeg",
    "https://cdn.faire.com/fastly/173d54e5f315e25a58951d20982f1514963c1863517db4b1db551f69c846efe3.jpeg",
    "https://cdn.faire.com/fastly/13e6774737dc9d60510c150ae75dbd60847eaa904ad3c939753482255fe4146e.jpeg",
    "https://cdn.faire.com/fastly/bfb27f6f974d983e72af483d1d025f19fdfb27429f6d8380a070d9418a0bb609.jpeg",
    "https://cdn.faire.com/fastly/29ff4ddf8034b4318e92e26131f99f3a96c1d7f0a768c80cf6f3fe2d038814ef.jpeg",
    "https://cdn.faire.com/fastly/dd0dbc80aff4b0e4a8974f3e453994ce2562ef42b1c314c54662d030b7cec3d0.jpeg",
    "https://cdn.faire.com/fastly/e31c0ce4a60996224e88c096f1fb379330a465b880c520e515e99f8d02257c90.jpeg",
    "https://cdn.faire.com/fastly/99b5cca22b1b5a3bbf6f5927978d8db22808ca4390acdcf961b7ba6657235356.jpeg",
    "https://cdn.faire.com/fastly/3b7c0e07cfb8efd37cc49b87704a8d37bd4bffdb470e14351610cdf6f830b9d8.jpeg",
    "https://cdn.faire.com/fastly/7949ddf345c58dbd7ac2d6b493ca38b300044c1af90a3a6178b1ef9ac349ffdc.jpeg",
  ],
  priceDollars: 75,
  description:
    "Mahjong is an exciting game of skill, chance, and strategy that tests a players’ observation and memory skills. The game originated in China; possibly as long as 2500 year ago, although the oldest historical record of the game is from the mid-1800’s. The Chinese symbols and characters on the tiles are known as Simples, Honors, and Bonuses. The Verve Culture Mahjong Set features handmade wooden tiles and a wooden box, along with simple instructions.\n\nPlease note this set is for the Chinese version of Mahjong. If you would like to purchase blank tiles to play another version, please reach out to us directly.",
  tags: [],
  msrpDollars: 150,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:34.953Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
